import { CoachTqReviewType } from '@airreading/common/data';

export const CoachTqReviewTypeBadgeClassMap: Record<CoachTqReviewType, string> = {
  [CoachTqReviewType.Quick]: 'bg-amber-100 text-amber-800 border-amber-200',
  [CoachTqReviewType.Focus]: 'bg-violet-100 text-violet-800 border-violet-200',
  [CoachTqReviewType.Assessment]: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  [CoachTqReviewType.PM_GLA]: 'bg-teal-100 text-teal-800 border-teal-200',
  [CoachTqReviewType.Tech_issue]: 'bg-slate-100 text-slate-800 border-slate-200',
  [CoachTqReviewType.ProA]: 'bg-indigo-100 text-indigo-800 border-indigo-200',
};
